module.exports = __webpack_public_path__ + "static/img/partner8.4316357.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/partner8.png
// module id = B7QI
// module chunks = 202